import { render } from "./2017-08-31-Geoserver.md?vue&type=template&id=4a6fbcd3"
const script = {}
script.render = render

export default script